import home from './home'
import userBack from './userBack'
import menuListManager from './menuList'

const customerManager = [
  {
    path: '/customer-manager',
    name: 'customer-manager',
    component: () => import('@/views/wxapp/customer-manager/'),
    redirect: '/customer-manager/home',
    meta: {
      title: '客户经理'
    },
    children: [
      {
        path: 'home',
        name: 'customer-manager-home',
        component: () => import('@/views/wxapp/customer-manager/home'),
        redirect: '/customer-manager/home/homePage',
        children: [
          {
            path: 'homePage',
            name: 'CM-home-homePage',
            component: () => import('@/views/wxapp/customer-manager/home/homePage.vue'),
            meta: {
              title: '客户经理工作台'
            }
          },
          {
            path: 'informationList',
            name: 'CM-home-informationList',
            component: () => import('@/views/wxapp/customer-manager/home/informationList.vue'),
            meta: {
              title: '消息通知'
            }
          },
          {
            path: 'dataAnalysis',
            name: 'dataAnalysis',
            component: () => import('@/views/wxapp/customer-manager/dataAnalysis'),
            meta: {
              title: '数据分析'
            }
          },
          {
            path: 'customer',
            name: 'customer',
            component: () => import('@/views/wxapp/customer-manager/statistics/index'),
            meta: {
              title: '客户经理工作台'
            }
          },
          {
            path: 'customer-list',
            name: 'customerManagerCustomerList',
            component: () => import('@/views/wxapp/service-system/list'),
            meta: {
              title: '我的用户'
            }
          }
        ]
      },
      {
        path: 'customer-sign',
        name: 'customer-sign',
        component: () => import('@/views/wxapp/customer-manager/customerSign'),
        meta: {
          title: '用户上门'
        }
      },
      {
        path: 'follow-user',
        name: 'FollowUser',
        component: () => import('@/views/wxapp/customer-manager/followUser'),
        meta: {
          title: '跟进用户'
        }
      },
      {
        path: 'order-list',
        name: 'order-list',
        component: () => import('@/views/wxapp/customer-manager/orderList'),
        meta: {
          title: '下订列表'
        }
      },
      {
        path: 'quick-order/:phone',
        name: 'QuickOrder',
        component: () => import('@/views/wxapp/customer-manager/quickOrder'),
        meta: {
          title: '快速下订'
        },
        props: true
      },
      {
        path: 'quick-order-opp/:opportunityId',
        name: 'QuickOrderOpp',
        component: () => import('@/views/wxapp/customer-manager/quickOrderOpp/index.vue'),
        meta: {
          title: '用户下订'
        },
        props: true
      },
      {
        path: 'turnBigInfo',
        name: 'turnBigInfo',
        component: () => import('@/views/wxapp/customer-manager/turnBig/indexInfo'),
        meta: {
          title: '继续收订'
        }
      },
      {
        path: 'turnBigInfoNew',
        name: 'turnBigInfoNew',
        component: () => import('@/views/wxapp/customer-manager/turnBig/indexInfoNew'),
        meta: {
          title: '重新收款'
        }
      },
      {
        path: 'checkoutCounter/:info/',
        name: 'checkoutCounter',
        component: () => import('@/views/wxapp/customer-manager/checkoutCounter/index.vue'),
        props: true,
        meta: {
          title: '合同收款'
        }
      },
      ...home,
      ...userBack,
      ...menuListManager,
      {
        path: 'opportunity',
        name: 'opportunity',
        component: () => import('@/views/wxapp/customer-manager/arrivalConfirmation/opportunity'),
        meta: {
          title: '到店确认'
        }
      },
      {
        path: 'turn-designer',
        name: 'turn-designer',
        component: () => import('@/views/wxapp/customer-manager/turnDesigner'),
        meta: {
          title: '转设计师'
        }
      },
      {
        path: 'site-confirmation',
        name: 'site-confirmation',
        component: () => import('@/views/wxapp/customer-manager/confirmation'),
        meta: {
          title: '预上门用户'
        }
      },
      {
        path: 'user-defined',
        name: 'UserDefined',
        component: () => import('@/views/wxapp/customer-manager/userDefined/index.vue'),
        meta: {
          title: '用户下订'
        }
      },
      {
        path: 'wait-designer',
        name: 'wait-designer',
        component: () => import('@/views/wxapp/customer-manager/waitDesigner'),
        meta: {
          title: '转设计师'
        }
      },
      {
        path: 'end-designer',
        name: 'end-designer',
        component: () => import('@/views/wxapp/customer-manager/endDesigner'),
        meta: {
          title: '已转设计师'
        }
      },
      {
        path: 'charge-back',
        name: 'charge-back',
        component: () => import('@/views/wxapp/customer-manager/chargeBack'),
        meta: {
          title: '退单客户'
        }
      },
      {
        path: 'follow',
        name: 'follow',
        component: () => import('@/views/wxapp/customer-manager/follow'),
        meta: {
          title: '今日需联系'
        }
      },
      {
        path: 'undetermined',
        name: 'undetermined',
        component: () => import('@/views/wxapp/customer-manager/undetermined'),
        meta: {
          title: '继续收订'
        }
      },
      {
        path: 'commissioned-design',
        name: 'commissionedDesign',
        component: () => import('@/views/wxapp/customer-manager/commissionedDesign'),
        meta: {
          title: '委托设计'
        }
      },
      {
        path: 'commissioned-design-invite',
        name: 'CommissionedDesignCreatedInvitation',
        component: () => import('@/views/wxapp/customer-manager/commissionedDesign/createdInvitation'),
        meta: {
          title: '委托设计邀请函'
        }
      },

      {
        path: 'need-follow',
        name: 'need-follow',
        component: () => import('@/views/wxapp/customer-manager/follow/followNext/followNext.vue'),
        meta: {
          title: '跟进用户'
        }
      },
      {
        path: 'back-list',
        name: 'back-list',
        component: () => import('@/views/wxapp/customer-manager/backMoney'),
        meta: {
          title: '退款/退单'
        }
      },
      {
        path: 'list',
        name: 'list',
        component: () => import('@/views/wxapp/customer-manager/backMoney/list/backList.vue'),
        meta: {
          title: '退款不退单'
        }
      },
      {
        path: 'listAll',
        name: 'listAll',
        component: () => import('@/views/wxapp/customer-manager/backMoney/list/backListAll.vue'),
        meta: {
          title: '用户退款退单'
        }
      },
      {
        path: 'approval',
        name: 'Approval',
        component: () => import('@/views/wxapp/customer-manager/backMoney/list/approval.vue'),
        meta: {
          title: '退款审批'
        }
      },
      {
        path: 'basicMessageConfirm',
        name: 'basicMessageConfirm',
        component: () => import('@/views/wxapp/customer-manager/basicMessage/basic.vue'),
        meta: {
          title: '基础信息确认'
        }
      },
      {
        path: 'basic-message',
        name: 'basic-message',
        component: () => import('@/views/wxapp/customer-manager/basicMessage/messageNew.vue'),
        meta: {
          title: '用户基础信息'
        }
      },
      {
        path: 'measuringRoom',
        name: 'measuringRoom',
        component: () => import('@/views/wxapp/customer-manager/measuringRoom'),
        meta: {
          title: '待勘测邀请'
        }
      },
      // {
      //   path: 'createdInvitation',
      //   name: 'createdInvitation',
      //   component: () => import('@/views/wxapp/customer-manager/measuringRoom/createdInvitation'),
      //   meta: {
      //     title: '创建勘测邀请函'
      //   }
      // },

      // 勘测邀请函
      {
        path: 'created-invitation',
        name: 'CreatedInvitation',
        component: () => import('@/views/wxapp/customer-manager/unDesigner/createdInvitation'),
        meta: {
          title: '勘测邀请函'
        }
      },

      {
        path: 'invite',
        name: 'rad-invite',
        component: () => import('@/views/wxapp/customer-manager/rad1/invite'),
        meta: {
          title: '创建初步需求评估邀请'
        }
      },
      {
        path: 'rad1-list',
        name: 'rad1-list',
        component: () => import('@/views/wxapp/customer-manager/rad1/list'),
        meta: {
          title: '需求评估'
        }
      },
      {
        path: 'visitDoor',
        name: 'visitDoor',
        component: () => import('@/views/wxapp/customer-manager/visitDoor'),
        meta: {
          title: '退单用户'
        }
      },
      {
        path: 'dataAnalysis',
        name: 'dataAnalysis',
        component: () => import('@/views/wxapp/customer-manager/dataAnalysis'),
        meta: {
          title: '数据分析'
        }
      },
      {
        path: 'my-self-receipt',
        name: 'MyselfReceipt',
        component: () => import('@/views/wxapp/customer-manager/myselfReceipt'),
        meta: {
          title: '我的收款单'
        }
      },
      {
        path: 'my-self-receipt-info',
        name: 'MyselfReceiptInfo',
        component: () => import('@/views/wxapp/customer-manager/myselfReceipt/info.vue'),
        meta: {
          title: '我的收款单'
        }
      },
      {
        path: 'receipt-details',
        name: 'ReceiptDetails',
        component: () => import('@/views/wxapp/customer-manager/myselfReceipt/details/index'),
        meta: {
          title: '我的收款单'
        }
      },
      {
        path: 'view-authorization',
        name: 'ViewAuthorization',
        component: () => import('@/views/wxapp/customer-manager/myselfReceipt/details/viewAuthorization'),
        meta: {
          title: '查看审批单'
        }
      },
      {
        path: 'follow-up-today',
        name: 'FollowUpToday',
        component: () => import('@/views/wxapp/customer-manager/followUpToday'),
        meta: {
          title: '今日需跟进'
        }
      },
      {
        path: 'invitation-located',
        name: 'InvitationLocated',
        component: () => import('@/views/wxapp/customer-manager/invitationLocated'),
        meta: {
          title: '待定位邀请'
        }
      },
      {
        path: 'deepen-scheme',
        name: 'DeepenScheme',
        component: () => import('@/views/wxapp/customer-manager/deepenScheme'),
        meta: {
          title: '待深化邀请'
        }
      },
      {
        path: 'advance-sales-contract-opportunity',
        name: 'Opportunitylist',
        component: () => import('@/views/wxapp/customer-manager/advanceSalesContract/opportunityList'),
        meta: {
          title: '预售合同'
        }
      },
      {
        path: 'unDesigner',
        name: 'UnDesigner',
        component: () => import('@/views/wxapp/customer-manager/unDesigner'),
        meta: {
          title: '转设计师'
        }
      },
      {
        path: 'highSeasPool',
        name: 'HighSeasPool',
        component: () => import('@/views/wxapp/customer-manager/home/internationalWater/highSeasPool'),
        meta: {
          title: '公海池'
        }
      },
      {
        path: 'highSeasPoolDetails',
        name: 'HighSeasPoolDetails',
        component: () => import('@/views/wxapp/customer-manager/home/internationalWater/highSeasPoolDetails'),
        meta: {
          title: '公海客户明细'
        }
      },
      {
        path: 'highSeasPreview',
        name: 'HighSeasPreview',
        component: () => import('@/views/wxapp/customer-manager/home/internationalWater/highSeasPreview'),
        meta: {
          title: '公海预面谈'
        }
      },
      {
        path: 'highSeasPreviewDetails',
        name: 'HighSeasPreviewDetails',
        component: () => import('@/views/wxapp/customer-manager/home/internationalWater/highSeasPreviewDetails'),
        meta: {
          title: '客户明细'
        }
      },
      {
        path: 'highSeasPreviewResources',
        name: 'HighSeasPreviewResources',
        component: () => import('@/views/wxapp/customer-manager/home/internationalWater/highSeasPreviewResources'),
        meta: {
          title: '资源跟进'
        }
      },
      {
        path: 'reserve-plan',
        name: 'ReservePlan',
        component: () => import('@/views/wxapp/customer-manager/reservePlan'),
        meta: {
          title: '预上门预案'
        }
      },
      {
        path: 'second-invitation',
        name: 'SecondInvitationPage',
        component: () => import('@/views/wxapp/customer-manager/menuList/btnCollection/secondInvitation/secondInvitationPage/index.vue'),
        meta: {
          title: '二次邀约'
        }
      },
      {
        path: 'policy-matching',
        name: 'PolicyMatchingPage',
        component: () => import('@/views/wxapp/customer-manager/menuList/btnCollection/policyMatching/policyMatchingPage/index.vue'),
        meta: {
          title: '基础信息确认'
        }
      },
      {
        path: 'no-visit-store',
        name: 'NoVisitStore',
        component: () => import('@/views/wxapp/customer-manager/noVisitStore/index.vue'),
        meta: {
          title: '未到店客户'
        }
      },
      {
        path: 'pending-customer-leave-list',
        name: 'pendingCustomerLeaveList',
        component: () => import('@/views/wxapp/customer-manager/pendingCustomerLeaveList/index.vue'),
        meta: {
          title: '待离店用户'
        }
      },
      {
        path: 'ai-workflow-task',
        name: 'AiWorkflowTask',
        component: () => import('@/views/wxapp/customer-manager/aiWorkflowTask/index.vue'),
        meta: {
          title: 'AI工作流任务'
        }
      },
      {
        path: 'to-be-proposed',
        name: 'toBeProposed',
        component: () => import('@/views/wxapp/customer-manager/toBeProposed/index.vue'),
        meta: {
          title: '待提案用户'
        }
      }
    ]
  }
]
export default customerManager
